import React, { useEffect } from "react";
import { useGetClientTouchPointsQuery } from "../../../../redux/service/modules/sales";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useSelector } from "react-redux";
import CustomCurrencyFormat from "../../../../components/common/CurrencyFormatter";

const ServiceTouchPoints = ({ appliedFilters, setRequiredFilters }) => {
    const dateRange = useSelector((state) => state.date);
    useEffect(() => {
        setRequiredFilters(["user"]);
    }, []);

    const customCellRender = {
        overall_service_cost: (row) => {
            return <CustomCurrencyFormat value={row['overall_service_cost']} />;
        }
    };

    
    return (
        <PaginatedDataTable
            queryHook={useGetClientTouchPointsQuery}
            initialDateRange={dateRange}
            firstColumnWidth="100px"
            isColumnSticky={true}
            appliedFilters={appliedFilters}
            stickyColumnsCount={2}
            customCellRender={customCellRender}
        />
    );
};

export default ServiceTouchPoints;
